var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", [
    _c("td", { staticClass: "chart-rank" }, [_vm._v("#" + _vm._s(_vm.rank))]),
    _vm._v(" "),
    _c("td", { staticClass: "chartColor" }, [
      _c(
        "div",
        { staticClass: "chartColor__box", class: _vm.chartColorClass },
        [_vm._v(" ")]
      )
    ]),
    _vm._v(" "),
    _c("td", { staticClass: "pieTable__key" }, [
      _vm._v(_vm._s(_vm.productName))
    ]),
    _vm._v(" "),
    _c("td", { staticClass: "pieTable__value" }, [
      _vm._v(_vm._s(_vm.product.units))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }